var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotions-carousel"},[_c('Carousel',{attrs:{"autoplayLoop":true,"autoplayTimeout":2500,"autoplay":false,"loop":true,"speed":700,"paginationEnabled":false,"navigationEnabled":false,"scrollPerPage":false,"autoplayHoverPause":true,"centerMode":false,"perPageCustom":[
            [320, 2],
            [400, 2],
            [800, 2],
            [1000, 3],
            [1200, 5],
            [1500, 5],
            [1600, 6] ]}},_vm._l((_vm.items),function(item,index){return _c('slide',{key:index,staticClass:"slider-item"},[_c('router-link',{staticClass:"slider-item__link",attrs:{"to":_vm.$localize({
                        name: 'card',
                        params: {
                            item: item.slug,
                            id: item.id,
                        },
                    })}},[_c('div',{staticClass:"promotions--slider"},[_c('div',{staticClass:"promotions-slide"},[_c('div',{staticClass:"promotions-slide__imgWrapper"},[_c('p',{staticClass:"action--button"},[_vm._v(_vm._s(_vm.$t('promotion')))]),_c('img',{attrs:{"src":item.image,"alt":item.title}})]),_c('div',{staticClass:"card-info__rating"},[_c('star-rating',{attrs:{"max-rating":5,"increment":0.1,"rating":item.rating,"star-points":[
                                    50.0,
                                    0.0,
                                    55.226,
                                    0.274,
                                    60.396,
                                    1.093,
                                    65.451,
                                    2.447,
                                    70.337,
                                    4.323,
                                    75.0,
                                    6.699,
                                    79.389,
                                    9.549,
                                    83.457,
                                    12.843,
                                    87.157,
                                    16.544,
                                    90.451,
                                    20.611,
                                    93.301,
                                    25.0,
                                    95.677,
                                    29.663,
                                    97.553,
                                    34.549,
                                    98.907,
                                    39.604,
                                    99.726,
                                    44.774,
                                    100.0,
                                    50.0,
                                    99.726,
                                    55.226,
                                    98.907,
                                    60.396,
                                    97.553,
                                    65.451,
                                    95.677,
                                    70.337,
                                    93.301,
                                    75.0,
                                    90.451,
                                    79.389,
                                    87.157,
                                    83.457,
                                    83.457,
                                    87.157,
                                    79.389,
                                    90.451,
                                    75.0,
                                    93.301,
                                    70.337,
                                    95.677,
                                    65.451,
                                    97.553,
                                    60.396,
                                    98.907,
                                    55.226,
                                    99.726,
                                    50.0,
                                    100.0,
                                    44.774,
                                    99.726,
                                    39.604,
                                    98.907,
                                    34.549,
                                    97.553,
                                    29.663,
                                    95.677,
                                    25.0,
                                    93.301,
                                    20.611,
                                    90.451,
                                    16.544,
                                    87.157,
                                    12.843,
                                    83.457,
                                    9.549,
                                    79.389,
                                    6.699,
                                    75.0,
                                    4.323,
                                    70.337,
                                    2.447,
                                    65.451,
                                    1.093,
                                    60.396,
                                    0.274,
                                    55.226,
                                    0.0,
                                    50.0,
                                    0.274,
                                    44.774,
                                    1.093,
                                    39.604,
                                    2.447,
                                    34.549,
                                    4.323,
                                    29.663,
                                    6.699,
                                    25.0,
                                    9.549,
                                    20.611,
                                    12.843,
                                    16.544,
                                    16.544,
                                    12.843,
                                    20.611,
                                    9.549,
                                    25.0,
                                    6.699,
                                    29.663,
                                    4.323,
                                    34.549,
                                    2.447,
                                    39.604,
                                    1.093,
                                    44.774,
                                    0.274,
                                    50.0,
                                    0.0 ],"inactive-color":"#C4C4C4","active-color":"#FFC315","read-only":true,"show-rating":false}})],1)]),_c('div',{staticClass:"product-title"},[_c('p',[_vm._v(_vm._s(item.title))])]),_c('div',{staticClass:"card-info__price-current"},[_c('div',{staticClass:"discount-product__price-current"},[(item.discount_price !== 0)?_c('span',[_vm._v(_vm._s(item.discount_price))]):_vm._e(),_c('span',{class:{ discount: item.discount_price !== 0 }},[_vm._v(_vm._s(item.price))])])])])])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }